import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useSportConfig } from '../context/SportConfig';
import useMdEntries from '../hooks/useMdEntries';
import '../styles/InfoPages.css';

function News() {
  const { entries, loading, error } = useMdEntries('news.md');
  const sportConfig = useSportConfig();
  const navTitle = sportConfig ? `${sportConfig.appEmoji} ${sportConfig.appName}` : '…';

  return (
    <div className="info-page">
      <Helmet>
        <title>News — Fantastic Tennis Fantasy League</title>
        <meta name="description" content="Latest news and updates from Fantastic Tennis — the fantasy tennis league platform for ATP and WTA fans. Hero Mode, snake draft, scoring updates, tournament announcements, and more." />
        <link rel="canonical" href="https://tennis.playfantastic.net/news" />
      </Helmet>
      <nav className="info-page-nav">
        <div className="nav-left">
          <Link to="/" className="nav-title-link">
            <h1 className="nav-title">{navTitle}</h1>
          </Link>
        </div>
        <div className="nav-right">
          <Link to="/faq" className="btn btn-secondary">FAQ</Link>
          <Link to="/login" className="btn btn-secondary">Login</Link>
          <Link to="/signup" className="btn btn-primary">Sign Up</Link>
        </div>
      </nav>

      <div className="info-page-content">
        <header className="info-page-header">
          <h2>📰 News &amp; Updates</h2>
          <p>What's new on {sportConfig?.appName || 'Fantastic Tennis'}</p>
        </header>

        {loading && <p className="info-page-loading">Loading news...</p>}
        {error && <p className="info-page-error">{error}</p>}

        {!loading && !error && (
          <div className="info-entry-list">
            {entries.map((entry, i) => (
              <div key={i} className="info-page-entry">
                <h3>{entry.title}</h3>
                {entry.date && <p className="info-page-date">{entry.date}</p>}
                <p className="info-page-body">{entry.body}</p>
              </div>
            ))}
          </div>
        )}

        <div className="info-page-back">
          <Link to="/" className="btn btn-secondary">← Back to Home</Link>
          <Link to="/faq" className="btn btn-secondary">View FAQ →</Link>
        </div>
      </div>
    </div>
  );
}

export default News;
